export const adminRoutes = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/dashboard/dashboard-show.vue'),
        children: [
            {
                path: '/customers/:customerId',
                component: () => import(/* webpackChunkName: "js/sales" */ './views/employees/customers/customer-show.vue'),
                props: true,
            },
            {
                path: '/customers/:customerId/locations/:customerLocationId',
                component: () => import(/* webpackChunkName: "js/sales" */ './views/employees/customers/customer-show.vue'),
                props: true,
            },
            {
                path: '/customers/:customerId/invoices/:invoiceId',
                component: () => import(/* webpackChunkName: "js/sales" */ './views/employees/customers/customer-invoice-edit.vue'),
                props: true,
            },
            {
                path: '/customers/:customerId/orders/:orderId',
                component: () => import(/* webpackChunkName: "js/sales" */ './views/employees/customers/customer-order-edit.vue'),
                props: true,
            },
            {
                path: '/customers/:customerId/renewals/:renewalId',
                component: () => import('./views/employees/renewals/renewal-customer.vue'),
                props: true,
            },
            {
                path: '/jobs/:jobId',
                component: () => import(/* webpackChunkName: "js/engineering" */ './views/employees/jobs/job-show.vue'),
                props: true,
            },
        ],
        meta: {
            title: 'Customers',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/users',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/users/admin-users-index.vue'),
        meta: {
            roles: ['user_admin'],
            title: 'Users',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/gl-codes',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/gl-codes/admin-gl-codes-index.vue'),
        meta: {
            roles: ['settings_admin'],
            title: 'Gl Codes',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/gl-transactions',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/gl-transactions/admin-gl-transactions-index.vue'),
        meta: {
            roles: ['settings_admin'],
            title: 'GL Transactions',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/gl-transactions-ledger',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/gl-transactions/gl-transactions-ledger-index.vue'),
        meta: {
            roles: ['settings_admin'],
            title: 'GL Transactions Ledger',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/bc-sync-dashboard',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/bc-sync/bc-sync-dashboard.vue'),
        meta: {
            roles: ['system_admin'],
            title: 'BC Sync Dashboard',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/departments',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/departments/departments-index.vue'),
        meta: {
            roles: ['settings_admin'],
            title: 'Departments',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/branches',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/branches/admin-branches-index.vue'),
        meta: {
            roles: ['settings_admin'],
            title: 'Branches',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/vehicle-types',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/vehicle-types/admin-vehicle-type-index.vue'),
        meta: {
            roles: ['exchange_admin'],
            title: 'Vehicle Types',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/item-prefixes',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/item-prefixes/admin-item-prefix-index.vue'),
        meta: {
            roles: ['item_admin'],
            title: 'Item Prefixes',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/tank-label-users',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/tank-label-users/admin-tank-label-user-index.vue'),
        meta: {
            roles: ['system_admin'],
            title: 'Tank Label Users',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/printers',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/printers/admin-printer-index.vue'),
        meta: {
            roles: ['system_admin'],
            title: 'Printers',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/scout',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/scout/admin-scout-index.vue'),
        meta: {
            roles: ['system_admin'],
            title: 'Scout Indexes',
            includeInMenu: false,
        },
    },
    {
        path: '/membrane-types',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/membrane-types/membrane-type-index.vue'),
        meta: {
            roles: ['membrane_admin'],
            title: 'Membrane Types',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/proposals-email-attachments',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/proposal-email-attachment/admin-proposal-email-attachment-index.vue'),
        meta: {
            roles: ['onboarding', 'resource_admin'],
            title: 'Proposal Email Attachments',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/water-linx-packages',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/water-linx-packages/admin-water-linx-package-index.vue'),
        meta: {
            roles: ['onboarding'],
            title: 'Water Linx Packages',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/proposal-terms',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/proposal-terms/admin-proposal-term-index.vue'),
        meta: {
            roles: ['onboarding'],
            title: 'Proposal Terms',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/customer-referral-sources',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/customer-referral-sources/admin-customer-referral-source-index.vue'),
        meta: {
            roles: ['onboarding'],
            title: 'Proposal Terms',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/business-central-accounts',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/business-central-accounts/admin-business-central-accounts-index.vue'),
        meta: {
            roles: ['settings_admin'],
            title: 'Business Central Accounts',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/voice-agent-call-log',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/voice-agent/admin-voice-agent-call-log-index.vue'),
        meta: {
            roles: ['system_admin'],
            title: 'Voice Agent Calls',
            includeInMenu: true,
        },
    },
    {
        path: '/admin/ai-chat',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/ai-chat/admin-ai-chat-index.vue'),
        meta: {
            roles: ['system_admin'],
            title: 'AI Chat',
            includeInMenu: false,
        },
    },
    {
        path: '/admin/hubspot-sync',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/admin/hubspot/admin-hubspot-sync-index.vue'),
        meta: {
            roles: ['system_admin'],
            title: 'HubSpot Sync',
            includeInMenu: true,
        },
    },
];

export const dashboardRoutes = [
    {
        path: '/dashboard',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/dashboard/dashboard-show.vue'),
        meta: {
            public: false,
        },
    },
];

export const resourceRoutes = [
    {
        path: '/resources/engineering/items',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/resources/resource-show.vue'),
        meta: {
            public: false,
            title: 'Engineering',
            includeInMenu: true,
        },
    },
    {
        path: '/resources/hr/items',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/resources/resource-show.vue'),
        meta: {
            public: false,
            title: 'HR',
            includeInMenu: true,
        },
    },
    {
        path: '/resources/marketing/items',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/resources/resource-show.vue'),
        meta: {
            public: false,
            title: 'Marketing',
            includeInMenu: true,
        },
    },

    {
        path: '/resources/regen/items',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/resources/resource-show.vue'),
        meta: {
            public: false,
            title: 'Regen',
            includeInMenu: true,
        },
    },
    {
        path: '/resources/sales/items',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/resources/resource-show.vue'),
        meta: {
            public: false,
            title: 'Sales',
            includeInMenu: true,
        },
    },
    {
        path: '/resources/sds/items',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/resources/resource-show.vue'),
        meta: {
            public: false,
            title: 'SDS',
            includeInMenu: true,
        },
    },
    {
        path: '/resources/service/items',
        component: () => import(/* webpackChunkName: "js/general" */ './views/employees/resources/resource-show.vue'),
        meta: {
            public: false,
            title: 'Service',
            includeInMenu: true,
        },
    },
];

export const billingRoutes = [
    {
        path: '/renewals/:customerId',
        props: true,
        component: () => import('./views/employees/renewals/renewal-index.vue'),
        meta: {
            includeInMenu: false,
            roles: ['billing_admin', 'onboarding'],
        },
    },
    {
        path: '/orders',
        component: () => import('@employees/billing-orders/billing-order-index.vue'),
        meta: {
            title: 'Orders',
            includeInMenu: true,
            roles: ['billing_admin', 'logistics_admin', 'ap_admin'],
        },
    },
    {
        path: '/orders/:orderId',
        beforeEnter: async (to, from, next) => {
            const Order = (await import('@models/order')).default;
            const order = await Order.with('customerLocation').find(to.params.orderId);
            next(`/customers/${order.customer_location.customer_id}/orders/${order.id}`);
        },
    },
    {
        path: '/invoices',
        component: () => import('@employees/billing-invoices/billing-invoice-index.vue'),
        meta: {
            title: 'Invoices',
            includeInMenu: true,
            roles: ['billing_admin', 'logistics_admin', 'ap_admin'],
        },
    },
    {
        path: '/customer-purchase-orders',
        component: () => import('@employees/billing-invoices/billing-customer-purchase-order-index.vue'),
        meta: {
            title: 'Customer Purchase Orders',
            includeInMenu: true,
            roles: ['billing_admin', 'logistics_admin', 'ap_admin'],
        },
    },
    {
        path: '/reimbursements',
        component: () => import('@employees/reimbursements/reimbursement-index.vue'),
        meta: {
            title: 'Reimbursements',
            includeInMenu: true,
            roles: ['ap_admin'],
        },
    },
    {
        path: '/aging-reports',
        component: () => import('@employees/aging-reports/aging-reports-index.vue'),
        meta: {
            title: 'Aging Report',
            includeInMenu: true,
            roles: ['ar_admin'],
        },
    },
    {
        path: '/ar-month-end',
        component: () => import(/* webpackChunkName: "js/reports" */ './views/employees/ar-month-end/ar-month-end-show.vue'),
        meta: {
            title: 'AR Month End',
            includeInMenu: true,
            roles: ['ar_admin'],
        },
    },
    {
        path: '/ar-reconciliation',
        component: () => import(/* webpackChunkName: "js/reports" */ './views/employees/ar-reconciliation/ar-reconciliation-index.vue'),
        meta: {
            title: 'AR Reconciliation',
            includeInMenu: true,
            roles: ['ar_admin'],
        },
    },
];

export const deliveryRoutes = [
    {
        path: '/routes',
        meta: {
            includeInMenu: true,
            title: 'Delivery Routes',
        },
        component: () => import(/* webpackChunkName: "js/delivery" */ '@components/route-app/route-app-index.vue'),
    },
    {
        path: '/routes/:route_id',
        meta: {
            roles: ['exchange_driver', 'service_technician'],
            title: 'Delivery Routes',
        },
        component: () => import(/* webpackChunkName: "js/delivery" */ '@components/route-app/route-app-show.vue'),
    },
    {
        path: '/route-details/:route_id',
        meta: {
            title: 'Route Details',
            includeInMenu: false,
        },
        component: () => import(/* webpackChunkName: "js/delivery" */ '@components/route/route-show.vue'),
        props: true,
    },
    {
        path: '/dispatch',
        meta: {
            includeInMenu: true,
            title: 'Dispatch',
            roles: ['dispatch'],
        },
        component: () => import(/* webpackChunkName: "js/delivery" */ './views/employees/dispatch/dispatch-show.vue'),
    },
    {
        path: '/dispatch/:date',
        meta: {
            title: 'Dispatch',
            roles: ['dispatch'],
        },
        component: () => import(/* webpackChunkName: "js/delivery" */ './views/employees/dispatch/dispatch-show.vue'),
    },
    {
        path: '/will-call',
        component: () => import(/* webpackChunkName: "js/sales" */ '@employees/will-call/will-call-index.vue'),
        meta: {
            title: 'Will Call',
            includeInMenu: true,
            roles: ['exchange_will_call'],
        },
    },
    {
        path: '/di-trailers',
        component: () => import(/* webpackChunkName: "js/delivery" */ './views/employees/di-trailers/di-trailer-index.vue'),
        meta: {
            title: 'DI Trailers',
            includeInMenu: true,
        },
    },
    {
        path: '/di-trailer-locations',
        component: () => import(/* webpackChunkName: "js/delivery" */ './views/employees/di-trailers/locations/di-trailer-location-index.vue'),
        meta: {},
    },
    {
        path: '/di-trailer-locations/:location_id',
        component: () => import(/* webpackChunkName: "js/delivery" */ './views/employees/di-trailers/locations/di-trailer-location-show.vue'),
        meta: {},
    },
    {
        path: '/di-trailers/:di_trailer_id',
        component: () => import(/* webpackChunkName: "js/delivery" */ './views/employees/di-trailers/di-trailer-show.vue'),
        meta: {},
    },

    {
        path: '/delivery/di-linx',
        component: () => import(/* webpackChunkName: "js/delivery" */ './views/employees/di-linx/di-linx-index.vue'),
        meta: {
            title: 'DI Linx',
            includeInMenu: true,
        },
    },
    {
        path: '/delivery/di-linx/:di_linx_id',
        component: () => import(/* webpackChunkName: "js/delivery" */ '@views/employees/di-linx/di-linx-show.vue'),
        meta: {},
    },
    {
        path: '/plant/tank-counts',
        component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/tank-counts/tank-count-index.vue'),
        meta: {
            title: 'Tank Counts',
            includeInMenu: true,
            roles: ['tank_counts'],
        },
    },
    {
        path: '/plant/tank-labels',
        component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/tank-labels/tank-labels-show.vue'),
        meta: {
            title: 'Tank Labels',
            includeInMenu: true,
        },
    },
    {
        path: '/plant/tank-upgrades',
        component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/tank-upgrades/tank-upgrades-show.vue'),
        meta: {
            title: 'Tank Upgrades',
            includeInMenu: true,
        },
    },
    {
        path: '/reports/resin-report',
        component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/tank-counts/resin-report-show.vue'),
        meta: {
            title: 'Resin Report',
            includeInMenu: true,
        },
    },
    // {
    //     path: '/plant/tank-logs',
    //     component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/tank-logs/tank-logs-index.vue'),
    //     meta: {
    //         roles: ['tank_logs'],
    //         title: 'Tank Logs',
    //         includeInMenu: true,
    //     },
    // },
    // {
    //     path: '/plant/tank-logs/:tankLogId',
    //     component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/tank-logs/tank-logs-index.vue'),
    //     meta: {
    //         roles: ['tank_logs'],
    //     },
    // },
    // {
    //     path: '/plant/tank-logs/:tankLogId',
    //     component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/tank-logs/tank-logs-index.vue'),
    //     meta: {
    //         roles: ['tank_logs'],
    //     },
    // },
    {
        path: '/plant/chemical',
        component: () => import(/* webpackChunkName: "js/plant" */ '@views/employees/chemical/chemical-index.vue'),
        meta: {
            title: 'Chemical',
            includeInMenu: true,
        },
    },
];

export const hrRoutes = [
    {
        path: '/hr/contact-list',
        component: () => import(/* webpackChunkName: "js/hr" */ '@views/employees/hr-contact-list/hr-contact-list-index.vue'),
        meta: {
            title: 'Employee Directory',
            includeInMenu: false,
        },
    },
    {
        path: '/employees',
        component: () => import(/* webpackChunkName: "js/hr" */ '@views/employees/hr-employees/hr-employees-index.vue'),
        meta: {
            roles: ['hr_admin'],
            title: 'Employees',
            includeInMenu: true,
        },
    },
    {
        path: '/hr/values-awards',
        component: () => import(/* webpackChunkName: "js/hr" */ '@views/employees/values-awards/values-award-index.vue'),
        meta: {
            roles: ['hr_admin'],
            title: 'Values Awards',
            includeInMenu: false,
        },
    },
    {
        path: '/hr/oxnard-miles',
        component: () => import(/* webpackChunkName: "js/hr" */ '@views/employees/oxnard-miles/oxnard-miles-index.vue'),
        meta: {
            title: 'Oxnard Miles',
            includeInMenu: false,
        },
    },
];

export const purchasingRoutes = [
    {
        path: '/purchase-requests',
        component: () => import(/* webpackChunkName: "js/purchasing" */ './views/employees/purchase-requests/purchase-requests-index.vue'),
        meta: {
            title: 'Purchase Requests',
            includeInMenu: true,
        },
    },
    {
        path: '/shipping-orders',
        component: () => import(/* webpackChunkName: "js/purchasing" */ '@employees/shipping-orders/shipping-orders-index.vue'),
        meta: {
            title: 'Shipping & Receiving',
            includeInMenu: true,
            roles: ['shipping', 'shipping_admin'],
        },
    },
    {
        path: '/items',
        component: () => import(/* webpackChunkName: "js/purchasing" */ './views/employees/items/items-index.vue'),
        meta: {
            title: 'Items',
            includeInMenu: true,
        },
    },
    {
        path: '/manufacturers',
        component: () => import(/* webpackChunkName: "js/admin" */ './views/employees/manufacturers/manufacturers-index.vue'),
        meta: {
            title: 'Manufacturers',
            includeInMenu: true,
        },
    },
    {
        path: '/purchasing/vendors',
        component: () => import(/* webpackChunkName: "js/purchasing" */ './views/employees/vendors/vendors-index.vue'),
        meta: {
            title: 'Vendors',
            includeInMenu: true,
        },
    },
    {
        path: '/purchasing/vendors/:vendorId',
        component: () => import(/* webpackChunkName: "js/purchasing" */ './views/employees/vendors/vendors-index.vue'),
        props: true,
    },
    {
        path: '/purchasing/purchase-items',
        component: () => import(/* webpackChunkName: "js/purchasing" */ './views/employees/purchase-items/purchase-items-history-index.vue'),
        meta: {
            title: 'Purchase Items',
            includeInMenu: false,
        },
    },
    {
        path: '/purchasing/purchase-items/:id/:individual',
        component: () => import(/* webpackChunkName: "js/purchasing" */ './views/employees/purchase-items/purchase-item-show.vue'),
    },
    {
        path: '/purchase-requests/:id',
        component: () => import(/* webpackChunkName: "js/purchasing" */ './views/employees/purchase-requests/purchase-request-show.vue'),
    },
    {
        path: '/purchasing/bill-of-materials',
        component: () => import(/* webpackChunkName: "js/purchasing" */ './views/employees/bill-of-materials/bill-of-materials-index.vue'),
        meta: {
            title: 'Bill of Materials',
            includeInMenu: true,
        },
    },
];

export const salesRoutes = [
    {
        path: '/proposals',
        meta: {
            title: 'Proposals',
            includeInMenu: true,
        },
        component: () => import(/* webpackChunkName: "js/sales" */ './views/employees/proposals/proposal-index.vue'),
    },
    {
        path: '/proposals/:proposal_id',
        redirect: '/proposals/:proposal_id/overview',
    },
    {
        path: '/proposals/:proposal_id/overview',
        component: () => import(/* webpackChunkName: "js/sales" */ './views/employees/proposals/proposal-show.vue'),
    },
    {
        path: '/engineering/jobs',
        component: () => import(/* webpackChunkName: "js/engineering" */ './views/employees/jobs/job-index.vue'),
        meta: {
            title: 'Jobs',
            includeInMenu: true,
        },
    },
    {
        path: '/cost-sheets',
        component: () => import(/* webpackChunkName: "js/engineering" */ './views/employees/cost-sheets/cost-sheets-index.vue'),
        meta: {
            title: 'Cost Sheets',
            includeInMenu: true,
        },
    },
    {
        path: '/cost-sheets/:id',
        component: () => import(/* webpackChunkName: "js/engineering" */ './views/employees/cost-sheets/cost-sheet-show.vue'),
    },
    {
        path: '/renewals',
        component: () => import('./views/employees/renewals/renewal-index.vue'),
        meta: {
            title: 'Renewals',
            includeInMenu: true,
            roles: ['billing_admin', 'onboarding'],
        },
    },
];

export const serviceRoutes = [
    {
        path: '/membrane-requests',
        component: () => import(/* webpackChunkName: "js/plant" */ '@views/employees/membrane-request/membrane-request-index.vue'),
        meta: {
            title: 'Membrane Cleaning',
            includeInMenu: true,
        },
    },
    {
        path: '/membrane-requests/:membraneRequestId',
        component: () => import(/* webpackChunkName: "js/plant" */ '@views/employees/membrane-request/membrane-request-show.vue'),
    },
    {
        path: '/routes',
        meta: {
            roles: ['exchange_driver', 'service_technician'],
            includeInMenu: true,
            title: 'Service Routes',
        },
        component: () => import(/* webpackChunkName: "js/delivery" */ '@components/route-app/route-app-index.vue'),
    },
    {
        path: '/service-schedule',
        name: 'service-schedule',
        component: () => import(/* webpackChunkName: "js/service" */ './views/employees/service-schedule/service-schedule-show.vue'),
        meta: {
            title: 'Schedule',
            includeInMenu: true,
            roles: ['schedule'],
        },
    },
    {
        path: '/reports/utilization',
        name: 'utilization-report',
        component: () => import(/* webpackChunkName: "js/reports" */ './views/employees/reports/utilization-report.vue'),
        meta: {
            title: 'Utilization Report',
            includeInMenu: false,
            roles: ['service_admin', 'logistics_admin'],
        },
    },
    {
        path: '/service-schedule/:date',
        name: 'service-schedule-day',
        component: () => import(/* webpackChunkName: "js/service" */ './views/employees/service-schedule/service-schedule-show.vue'),
        meta: {
            title: 'Schedule',
            includeInMenu: false,
            roles: ['schedule'],
        },
    },
    {
        path: '/water-linx',
        component: () => import(/* webpackChunkName: "js/service" */ './views/employees/water-linx/water-linx-index.vue'),
        meta: {
            title: 'Water Linx',
            includeInMenu: true,
        },
    },
    {
        path: '/water-linx/:water_linx_id',
        redirect: '/water-linx/:water_linx_id/dashboard',
    },
    {
        path: '/water-linx/:water_linx_id/dashboard',
        component: () => import(/* webpackChunkName: "js/service" */ '@views/employees/water-linx/water-linx-dashboard-show.vue'),
        meta: {

        },
    },
    {
        path: '/water-linx/:water_linx_id/history',
        component: () => import(/* webpackChunkName: "js/service" */ '@views/employees/water-linx/history/water-linx-history-index.vue'),
        meta: {

        },
    },
    {
        path: '/water-systems',
        component: () => import(/* webpackChunkName: "js/service" */ './views/employees/water-systems/water-system-index.vue'),
        meta: {
            title: 'Water System Logs',
            includeInMenu: true,
        },
    },
    {
        path: '/water-systems/:water_system_id',
        redirect: '/water-systems/:water_system_id/dashboard',
        component: () => import(/* webpackChunkName: "js/service" */ '@employees/water-systems/water-system-layout.vue'),
        children: [
            {
                path: 'dashboard',
                component: () => import(/* webpackChunkName: "js/service" */ '@views/employees/water-systems/water-system-dashboard-show.vue'),
            },
            {
                path: 'history',
                component: () => import(/* webpackChunkName: "js/service" */ '@views/employees/water-systems/history/water-system-history-index.vue'),
            },
            {
                path: 'attachments',
                component: () => import(/* webpackChunkName: "js/service" */ '@views/employees/water-systems/attachment/water-system-attachment-index.vue'),
            },
            {
                path: 'notes',
                component: () => import(/* webpackChunkName: "js/service" */ '@views/employees/water-systems/note/water-system-note-index.vue'),
            },

            {
                path: 'history/:water_system_log_id',
                component: () => import(/* webpackChunkName: "js/service" */ '@views/employees/water-systems/history/water-system-history-index.vue'),
            },
        ],
    },

];

export const userRoutes = [
    {
        path: '/ai-chat-popout',
        component: () => import(/* webpackChunkName: "js/ai-chat" */ './components/ai-chat/ai-chat-popout.vue'),
        meta: {
            layout: 'none',
        },
    },
    {
        path: '/user/profile',
        component: () => import(/* webpackChunkName: "js/user" */ './views/employees/user-profile/user-profile-information-show.vue'),
        meta: {
            public: false,
        },
    },
    {
        path: '/user/water-linx-settings',
        component: () => import(/* webpackChunkName: "js/user" */ './views/employees/user-profile/user-profile-water-linx-show.vue'),
    },
    {
        path: '/user/water-system-settings',
        component: () => import(/* webpackChunkName: "js/user" */ './views/employees/user-profile/user-profile-water-systems-show.vue'),
    },
    {
        // Vue Router 4 dropped the legacy '*' catch-all syntax in favor of
        // a parameterised wildcard match. See
        // https://router.vuejs.org/guide/migration/#Removed-star-or-catch-all-routes
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import(/* webpackChunkName: "js/public" */ './views/system/404.vue'),
        meta: {
            public: true,
        },
    },
];

export default [
    ...adminRoutes,
    ...billingRoutes,
    ...dashboardRoutes,
    ...deliveryRoutes,
    ...hrRoutes,
    ...purchasingRoutes,
    ...resourceRoutes,
    ...salesRoutes,
    ...serviceRoutes,
    ...userRoutes,
];
